import { createFileRoute, Outlet, redirect } from '@tanstack/react-router'

export const Route = createFileRoute('/_auth')({
  component: RouteComponent,
  beforeLoad: async ({ context: { session } }) => {
    if (session) {
      throw redirect({ to: '/' })
    }
    return session;
  },
})

function RouteComponent() {
  return <Outlet />
}
